import React, { useEffect, useState } from 'react';
import { sendBayilikBasvuruOtp, verifyBayilikBasvuruOtp } from '../services/bayilikBasvuruService';

const BayilikBasvuruOtpModal = ({
  isOpen,
  token,
  telefon,
  onSuccess,
  onClose,
}) => {
  const [otpKod, setOtpKod] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [resendCountdown, setResendCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setOtpKod('');
      setOtpSent(false);
      setCountdown(0);
      setResendCountdown(0);
      setError('');
    }
  }, [isOpen]);

  useEffect(() => {
    if (resendCountdown <= 0) return undefined;
    const timer = setInterval(() => setResendCountdown((prev) => (prev > 0 ? prev - 1 : 0)), 1000);
    return () => clearInterval(timer);
  }, [resendCountdown]);

  const handleSendOtp = async () => {
    if (!token || !telefon) return;
    setError('');
    setLoading(true);
    try {
      const res = await sendBayilikBasvuruOtp(token, telefon);
      setOtpSent(true);
      setCountdown(res?.veri?.gecerlilikSuresiSaniye || 150);
      setResendCountdown(res?.veri?.tekrarGonderSaniye || 30);
    } catch (err) {
      setError(err?.message || 'SMS gönderilemedi');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen || !telefon) return undefined;
    setOtpSent(false);
    setOtpKod('');
    setError('');
    handleSendOtp();
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, telefon]);

  useEffect(() => {
    if (countdown <= 0) return undefined;
    const timer = setInterval(() => setCountdown((prev) => (prev > 0 ? prev - 1 : 0)), 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const handleVerify = async () => {
    setError('');
    if (!/^[0-9]{6}$/.test(otpKod.trim())) {
      setError('6 haneli kod giriniz');
      return;
    }
    setLoading(true);
    try {
      const res = await verifyBayilikBasvuruOtp(token, telefon, otpKod.trim());
      onSuccess?.(res?.veri);
      onClose?.();
    } catch (err) {
      setError(err?.message || 'Doğrulama başarısız');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" role="presentation" onClick={() => !loading && onClose?.()}>
      <div
        className="modal-content bayilik-otp-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bayilik-otp-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 id="bayilik-otp-title">Telefon Doğrulama</h3>
          <button type="button" className="modal-close" onClick={onClose} disabled={loading} aria-label="Kapat">
            ×
          </button>
        </div>
        <div className="modal-body">
          {error && <div className="form-error">{error}</div>}
          <div className="form-group">
            <label htmlFor="bayilik-otp-kod">Doğrulama kodu</label>
            <input
              id="bayilik-otp-kod"
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={otpKod}
              onChange={(e) => setOtpKod(e.target.value.replace(/\D/g, '').slice(0, 6))}
              disabled={loading || !otpSent}
              autoComplete="one-time-code"
            />
          </div>
          {countdown > 0 && (
            <p className="bayilik-otp-countdown">Kalan süre: {countdown} sn</p>
          )}
          {resendCountdown > 0 ? (
            <p className="bayilik-otp-resend-wait">Tekrar gönder: {resendCountdown} sn</p>
          ) : (
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={handleSendOtp}
              disabled={loading}
            >
              Tekrar gönder
            </button>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
            İptal
          </button>
          <button type="button" className="btn btn-primary" onClick={handleVerify} disabled={loading}>
            Doğrula
          </button>
        </div>
      </div>
    </div>
  );
};

export default BayilikBasvuruOtpModal;
